import axios from "axios";

export const REGISTER_URL = "customer/register";
export const REQUEST_PASSWORD_URL = "api/auth/forgot-password";
export const ME_URL = "is-authenticated";

export function login(email, password) {

  return axios.post('auth/login', {
    email,
    password,
  });
}

export function register(mobile, password) {
  return axios.post(REGISTER_URL, { mobile, password, mobile_country:'IR'});
}

export function requestPassword(email) {
  return axios.post(REQUEST_PASSWORD_URL, { email });
}

export function getUserByToken() {
  // Authorization head should be fulfilled in interceptor.
  return axios.get(ME_URL);
}
